const USD_FORMAT = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatCurrency(value: string | null | undefined): string {
  if (!value) return '--';
  const num = parseFloat(value);
  if (Number.isNaN(num)) return value;
  return USD_FORMAT.format(num);
}
